//M.D 타입의 날짜 변환

function formatDateMD(dateString) {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return `${parseInt(month)}.${parseInt(day)}`;
}

export { formatDateMD };
